/** "48s" / "2m 05s" for duration stats; em-dash for missing values. */
export function fmtMs(ms: number | null | undefined): string {
  if (ms == null || ms < 0) return "—";
  const totalSeconds = Math.round(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  if (minutes === 0) return `${seconds}s`;
  return `${minutes}m ${String(seconds).padStart(2, "0")}s`;
}

/** Local calendar date N days ago as YYYY-MM-DD (for <input type="date">). */
export function isoDaysAgo(n: number): string {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
}

/** Inclusive YYYY-MM-DD pair -> [inclusive-from, EXCLUSIVE-to] ISO datetimes. */
export function toDateWindow(from: string, to: string): { date_from: string; date_to: string } {
  const end = new Date(`${to}T00:00:00Z`);
  end.setUTCDate(end.getUTCDate() + 1);
  return {
    date_from: `${from}T00:00:00Z`,
    date_to: end.toISOString().replace(".000Z", "Z"),
  };
}
